import { ContractLineValidator } from '@/services/validation/ContractLineValidator';

import { validationSchema } from './validationSchema';
import { VariableContractLineToCreate } from '../../hooks/useCreateContractLine';

export const validator = new ContractLineValidator<Partial<VariableContractLineToCreate>>(validationSchema);
